<template>
  <div class="field-add-select clearfix">
    <div class="form-group">
      <label class="col-sm-4 control-label">
        {{ field.label }}
        <span v-if="field.required" class="required">*</span>
      </label>
      <div class="col-sm-8">
        <select v-bind:name="field.name" class="form-control"
          v-model="field.value">
          <option value="" disabled>Select an option</option>
          <option v-for="selection in field.selections"
            v-bind:value="selection.value">{{ selection.label }}</option>
        </select>
        <span class="form-validation-error"
          v-show="!field.valid && field.dirty">Please select an option.</span>
        <span class="fa fa-check form-control-feedback
          form-control-feedback-success form-control-feedback-select"
          v-show="field.valid && field.dirty"></span>
        <span class="fa fa-remove form-control-feedback
          form-control-feedback-error form-control-feedback-select"
          v-show="!field.valid && field.dirty"></span>
          <br/><br/>
          <template v-for="selection in field.selections">
            <p v-if="selection.value == field.value" class="alert alert-warning">
              {{{ selection.note }}}
            </p>
          </template>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'DamageTypeSelect',
  props: {
    field: {
      type: Object,
      default () {
        return {
          label: 'Text',
          name: 'objectSelect',
          objectName: 'name',
          value: '',
          objects: []
        }
      }
    }
  },
  data () {
    return {
      fieldLength: 0
    }
  },
  watch: {
    'field.value': function (newVal, oldVal) {
      this.field.dirty = true
      this.field.valid = newVal.length > 0
      if (this.field.valid) {
        let form = this.$parent.form.sections
        for (let i = 0; i < this.field.dropdowns.length; i++) {
          let dropdown = this.field.dropdowns[i]
          if (dropdown.values.indexOf(this.field.value) !== -1) {
            if (this.field.value === 'undrivable') {
              this.$parent.form.permalink = 'carChange'
            } else if (
              this.field.value === 'drivable' ||
              this.field.value === 'drivableAtFault' ||
              this.field.value === 'undrivableAtFault'
            ) {
              this.$parent.form.permalink = 'newAccountNote'
            }
            if (this.fieldLength > 0) {
              form.length = form.length - this.fieldLength
            }
            for (let field of dropdown.fields) {
              field.value = ''
              form.push(field)
            }
            this.fieldLength = dropdown.fields.length
            this.$parent.form.sections = form
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// FieldAddSelectInput.vue?1eab711a